var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8369 16.3698C32.8369 7.47919 25.6297 0.271973 16.7391 0.271973C7.84857 0.271973 0.641357 7.47919 0.641357 16.3698C0.641357 24.4045 6.52805 31.0643 14.2239 32.272V21.023H10.1365V16.3698H14.2239V12.8232C14.2239 8.78871 16.6272 6.56017 20.3042 6.56017C22.0649 6.56017 23.9077 6.87458 23.9077 6.87458V10.8361H21.8779C19.8782 10.8361 19.2544 12.0771 19.2544 13.3514V16.3698H23.719L23.0053 21.023H19.2544V32.272C26.9502 31.0643 32.8369 24.4045 32.8369 16.3698Z",
    fill: "#565556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.08b3ea273d8a9820f4fd5f6859bdd647.svg";
export { ForwardRef as ReactComponent };